exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ":host {\n  width: 100% !important; }\n  :host .form {\n    width: 100% !important; }\n  :host .bar {\n    width: 800px !important; }\n  :host .card {\n    margin: 10px 0 !important; }\n\n.text-alert {\n  color: red; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/form/form/commerce-casefile-form/commerce-casefile-form.component.scss
// module id = 928
// module chunks = 0